module.exports = __webpack_public_path__ + "static/img/bg1.35fe703.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fourth/head/bg1.png
// module id = xAGh
// module chunks = 1